/*
 * @Description: 表格高度拖拽调整 mixin
 * @Author: Claude
 * @Date: 2026-04-17
 */

/**
 * 使用说明：
 * 1. 在页面 data 中配置拖拽相关属性：
 *    detailTableHeight: 400,      // 当前明细表格高度
 *    lastTableHeight: 400,        // 上次保存的高度
 *    minDetailHeight: 200,        // 最小高度
 *    maxDetailHeight: 700          // 最大高度
 *
 * 2. 在页面 methods 中添加 handleTableTitleResize 方法（可选）
 *
 * 3. 在组件中使用：
 *    <div class="drag-handle" :class="{ 'is-drag-active': isDragging }" @mousedown="handleDragStart"></div>
 *    <!-- 拖拽指示线，放在模板底部 -->
 *    <div class="drag-indicator" :style="dragIndicatorStyle" v-if="isDragging"></div>
 *
 * 4. 引入 mixin：
 *    import dragTableHeight from '@/mixins/drag-table-height';
 *    mixins: [dragTableHeight],
 *
 * 5. CSS 样式（可放到全局或组件内）：
 *    .drag-indicator {
 *      position: fixed;
 *      left: 0;
 *      right: 0;
 *      height: 2px;
 *      background: #409EFF;
 *      pointer-events: none;
 *      z-index: 9999;
 *    }
 */

export default {
  data() {
    return {
      isDragging: false,
      dragStartY: 0,
      dragIndicatorTop: 0 // 指示线位置
    };
  },
  computed: {
    dragIndicatorStyle() {
      return {
        top: this.dragIndicatorTop + 'px'
      };
    }
  },
  methods: {
    // 开始拖拽
    handleDragStart(e) {
      this.isDragging = true;
      this.dragStartY = e.clientY;
      this.dragIndicatorTop = e.clientY;
      document.addEventListener('mousemove', this.handleDragging);
      document.addEventListener('mouseup', this.handleDragEnd);
      // 防止选中文本
      e.preventDefault();
    },
    // 拖拽中
    handleDragging(e) {
      if (!this.isDragging) return;

      const deltaY = this.dragStartY - e.clientY;
      const newHeight = this.detailTableHeight + deltaY;
      //console.log(this.detailTableHeight, this.dragStartY);
      if (newHeight >= this.minDetailHeight && newHeight <= this.maxDetailHeight) {
        this.detailTableHeight = newHeight;
        this.dragStartY = e.clientY;
      }

      // 更新指示线位置
      this.dragIndicatorTop = e.clientY;
    },
    // 结束拖拽
    handleDragEnd() {
      this.isDragging = false;
      this.lastTableHeight = this.detailTableHeight;
      this.dragIndicatorTop = 0;
      document.removeEventListener('mousemove', this.handleDragging);
      document.removeEventListener('mouseup', this.handleDragEnd);

      this.$nextTick(() => {
        if (this.handleTableTitleResize) {
          this.handleTableTitleResize();
        }
      });
    }
  }
};
